import React from 'react';
// import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { Document, Page, pdfjs } from 'react-pdf';
import PropTypes from 'prop-types';
import { customerApprovalDocumentLookupServices } from '@ami/react/shared';
// import 'react-pdf/src/Page/AnnotationLayer.css';
// import 'react-pdf/dist/esm/Page/TextLayer.css';

class CustomerApprovalPdfViewer extends React.Component {
  constructor(props) {
    super(props);
    this.onDocumentLoadSuccess = this.onDocumentLoadSuccess.bind(this);
    this.onDownLoadResponse = this.onDownLoadResponse.bind(this);
    pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  }

  static propTypes = {
    documentId: PropTypes.string.isRequired,
    customerApprovalId: PropTypes.string.isRequired,
    onDownLoad: PropTypes.func.isRequired,
  };

  state = {
    base64String: '',
    numPages: 0,
  };

  async componentDidMount() {
    this.loadDocument();
  }

  loadDocument() {
    const { customerApprovalId, documentId } = this.props;
    customerApprovalDocumentLookupServices
      .getDownloadPdf(customerApprovalId, documentId)
      .then((response) => {
        this.setState({ base64String: response.base64Pdf });
        this.onDownLoadResponse(response.watermarkGenerated);
      });
  }

  onDownLoadResponse(watermarkGenerated) {
    if (watermarkGenerated) {
      this.props.onDownLoad(watermarkGenerated);
    } else {
      this.timeout = setTimeout(() => {
        this.loadDocument();
      }, 5000);
    }
  }

  onDocumentLoadSuccess({ numPages }) {
    this.setState({ numPages: numPages });
  }

  render() {
    const { base64String, numPages } = this.state;

    return (
      <div>
        {base64String && (
          <Document
            file={`data:application/pdf;base64,${base64String}`}
            onLoadSuccess={this.onDocumentLoadSuccess}
          >
            {numPages > 0 &&
              (() => {
                var rows = [];
                for (let i = 1; i <= numPages; i++) {
                  rows.push(
                    <div key={i}>
                      <Page size="A4" pageNumber={i} />
                    </div>
                  );
                }
                return rows;
              })()}
          </Document>
        )}
      </div>
    );
  }
}

export default CustomerApprovalPdfViewer;
